import { Navigate, Routes } from 'react-router-dom';

import { Route } from 'react-router-dom';
import { ApiAccess } from './DevTools/ApiAccess';
import { Webhooks } from './DevTools/Webhooks';
import DevToolsLayout from './DevTools/DevToolsLayout';
import { WebhooksAdd } from './DevTools/WebhooksAdd';
import { WebhooksDetails } from './DevTools/WebhooksDetails';

export const DevToolsRoutes = () => {
  return (
    <DevToolsLayout>
      <Routes>
        <Route path="/" element={<Navigate to="api-access" />} />
        <Route path="api-access" element={<ApiAccess />} />
        <Route path="webhooks" element={<Webhooks />} />
        <Route path="webhooks/create" element={<WebhooksAdd />} />
        <Route path="webhooks/:id" element={<WebhooksDetails />} />
      </Routes>
    </DevToolsLayout>
  );
};
